import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { LocationInfo } from '@/hooks/AdobeAnalyticsHooks/types/AdobeAnalyticsTypes';

export const useLocationInfo = (): LocationInfo => {
  const location = useLocation();

  const pathname = useMemo(() => location.pathname, [location.pathname]);
  const hostname = useMemo(() => window.location.hostname, []);
  const url = useMemo(() => window.location.href, []);

  return { pathname, hostname, url };
};
